import {Stack, Typography} from "@mui/material";
import {compoundAttachment} from "../../builder/WeaponBuilder";

const highlightConditions = [
    {
        condition: (a) => a.dmgRanges[0].modifier > 1,
        label: 'Damage Range'
    },
    {
        condition: (a) => (a.recoil.vertical + a.recoil.horizontal) < 1.95,
        label: 'Recoil Control'
    },
    {
        condition: (a) => a.rateOfFire > 1,
        label: 'Rate of Fire'
    },
    {
        condition: (a) => a.adsTime < 1,
        label: 'ADS Speed'
    },
    {
        condition: (a) => (a.sprintSpeed > 1) && (a.adsMoveSpeed > 1),
        label: 'Movement Speed'
    },
    {
        condition: (a) => a.sprintSpeed > 1 && a.adsMoveSpeed <= 1,
        label: 'Sprint Speed'
    },
    {
        condition: (a) => a.adsMoveSpeed > 1 && a.sprintSpeed <= 1,
        label: 'ADS Movement Speed'
    },
]

const lowlightConditions = [
    {
        condition: (a) => a.dmgRanges[0].modifier < 1,
        label: 'Damage Range'
    },
    {
        condition: (a) => (a.recoil.vertical + a.recoil.horizontal) > 2.05,
        label: 'Recoil Control'
    },
    {
        condition: (a) => a.rateOfFire < 1,
        label: 'Rate of Fire'
    },
    {
        condition: (a) => a.adsTime > 1,
        label: 'ADS Speed'
    },
    {
        condition: (a) => (a.sprintSpeed < 1) && (a.adsMoveSpeed < 1),
        label: 'Movement Speed'
    },
    {
        condition: (a) => (a.sprintSpeed < 1) && (a.adsMoveSpeed >= 1),
        label: 'Sprint Speed'
    },
    {
        condition: (a) => (a.adsMoveSpeed < 1) && (a.sprintSpeed >= 1),
        label: 'ADS Movement Speed'
    },
]

const HighLowLight = ({stat, sign}) => {
    return (
        <Stack direction='row' alignItems='center' sx={{p: {xs: 0, md: '5px'}}}>
            <Typography
                sx={{
                    fontSize: '1.25rem',
                    lineHeight: {xs: 0.7, md: 1},
                    fontWeight: 'bold',
                    color: sign === '+' ? 'green' : 'red',
                    p: '0 3px 5px 0'
                }}>
                {sign}
            </Typography>
            <Typography fontSize={{xs: '0.85rem', md: '1rem'}}>{stat}</Typography>
        </Stack>
    )
}

const LoadoutHighlights = ({attachments}) => {
    const highlights = []
    const lowlights = []
    const attachment = compoundAttachment(attachments);
    highlightConditions.forEach(h => {
        if (h.condition(attachment)) highlights.push(h.label)
    })
    lowlightConditions.forEach(h => {
        if (h.condition(attachment)) lowlights.push(h.label)
    })
    return (
        <Stack direction='row'
               sx={{color: 'white', width: {xs: '100%', md: 'auto'}, mr: {xs: null, md: '15px'}, justifyContent: 'space-evenly'}}>
            <Stack direction={{xs: 'column', md: 'row'}}>
                {highlights.map(stat => <HighLowLight key={`highlight-${stat}`} stat={stat} sign='+'/>)}
            </Stack>
            <Stack direction={{xs: 'column', md: 'row'}}>
                {lowlights.map(stat => <HighLowLight key={`lowlight-${stat}`} stat={stat} sign='-'/>)}
            </Stack>
        </Stack>
    )
}

export default LoadoutHighlights